import { Box } from '@mui/material';
import { FormProvider, UseFormReturn, SubmitHandler, FieldValues } from 'react-hook-form';

interface IFormProps {
	form: UseFormReturn;
	formId: string;
	onSubmit: SubmitHandler<FieldValues>;
	children: React.ReactNode;
}

export default function Form({ form, onSubmit, formId, children, ...props }: IFormProps) {
	return (
		<FormProvider {...form}>
			<Box component="form" onSubmit={form.handleSubmit(onSubmit)} noValidate id={formId} {...props}>
				{children}
			</Box>
		</FormProvider>
	);
}
